<template>
	<div class="ids">
		<div class="ids__elm">
			<!-- ///////////// -->
			<!-- SETTINGS -->
			<div class="ids__elm-settings">
				<div class="ids__elm-settings-label">Настройки</div>

				<!-- Отмечать входящие сообщения прочитанными -->
				<div class="ids__elm-settings-item">
					<div class="ids__elm-settings-item-key">
						<UiSwitcher
							:is-array-items="true"
							name="markIncomingMessagesReaded"
							:is-checked="isMarkIncomingMessagesRead"
							v-on:checked-item="handleChecked"
						/>
					</div>
					<div class="ids__elm-settings-item-val">
						Отмечать входящие сообщения прочитанными
					</div>
				</div>

				<!-- Отмечать входящие сообщения прочитаннымы при отправке через API -->
				<div class="ids__elm-settings-item">
					<div class="ids__elm-settings-item-key">
						<UiSwitcher
							:is-array-items="true"
							name="markIncomingMessagesReadedOnReply"
							:is-checked="isMarkIncomingMessagesReadOnReply"
							v-on:checked-item="handleChecked"
						/>
					</div>
					<div class="ids__elm-settings-item-val">
						Отмечать входящие сообщения прочитаннымы при отправке
						через API
					</div>
				</div>

				<!-- Разделительная линия -->
				<div class="ids__elm-settings-line"></div>

				<!-- Интервал отправки сообщений из очереди -->
				<div class="ids__elm-settings-interval">
					<div class="ids__elm-settings-interval-key">
						Интервал отправки сообщений из очереди
					</div>
					<div class="ids__elm-settings-interval-val">
						<div class="ids__elm-settings-interval-val-msec">
							{{ DELAY_SEND_MESSAGE }} мс
						</div>
					</div>
				</div>

				<!-- Уведомления -->
				<div class="ids__elm-settings-label_notify">Уведомления</div>

				<!-- Адрес отправки уведомлений (URL) -->
				<div class="ids__elm-settings-url-label">
					Адрес отправки уведомлений (URL)
				</div>
				<div class="ids__elm-settings-url">
					<div @click="onFocus" class="ids__elm-settings-url-wrap">
						<div
							v-if="!isFocus"
							class="ids__elm-settings-url-wrap-link"
						>
							{{ webhookUrl }}
						</div>

						<input
							ref="inputUrl"
							@focusout="onFocusOut"
							tabindex="0"
							v-show="isFocus"
							@input="inputUrl"
							:value="webhookUrl"
							type="text"
							class="ids__elm-settings-url-wrap-input"
							placeholder="URL"
						/>
					</div>

					<div class="ids__elm-settings-url-copy">
						<IconCopy
							class="ids__elm-settings-url-copy-icon"
							@click="onClipboard"
						/>
					</div>
				</div>

				<!-- Получать уведомления о входящих сообщениях и файлах -->
				<div class="ids__elm-settings-item">
					<div class="ids__elm-settings-item-key">
						<UiSwitcher
							:is-array-items="true"
							name="incomingWebhook"
							:is-checked="isIncomingWebhook"
							v-on:checked-item="handleChecked"
						/>
					</div>
					<div class="ids__elm-settings-item-val">
						Получать уведомления о входящих сообщениях и файлах
					</div>
				</div>

				<!-- Получать уведомления о статусах отправленных сообщениях -->
				<div class="ids__elm-settings-item">
					<div class="ids__elm-settings-item-key">
						<UiSwitcher
							:is-array-items="true"
							name="outgoingWebhook"
							:is-checked="isOutgoingWebhook"
							v-on:checked-item="handleChecked"
						/>
					</div>
					<div class="ids__elm-settings-item-val">
						Получать уведомления о статусах отправленных сообщениях
					</div>
				</div>

				<!-- Получать уведомления о сообщениях, отправленных с телефона -->
				<div class="ids__elm-settings-item">
					<div class="ids__elm-settings-item-key">
						<UiSwitcher
							:is-array-items="true"
							name="outgoingMessageWebhook"
							:is-checked="isOutgoingMessageWebhook"
							v-on:checked-item="handleChecked"
						/>
					</div>
					<div class="ids__elm-settings-item-val">
						Получать уведомления о сообщениях, отправленных с
						телефона
					</div>
				</div>

				<!-- Получать уведомления о сообщениях, отправленных с API -->
				<div class="ids__elm-settings-item">
					<div class="ids__elm-settings-item-key">
						<UiSwitcher
							:is-array-items="true"
							name="outgoingAPIMessageWebhook"
							:is-checked="isOutgoingAPIMessageWebhook"
							v-on:checked-item="handleChecked"
						/>
					</div>
					<div class="ids__elm-settings-item-val">
						Получать уведомления о сообщениях, отправленных с API
					</div>
				</div>

				<!-- Получать уведомления об изменении состояния авторизации аккаунта -->
				<div class="ids__elm-settings-item">
					<div class="ids__elm-settings-item-key">
						<UiSwitcher
							:is-array-items="true"
							name="stateWebhook"
							:is-checked="isStateWebhook"
							v-on:checked-item="handleChecked"
						/>
					</div>
					<div class="ids__elm-settings-item-val">
						Получать уведомления об изменении состояния авторизации
						аккаунта
					</div>
				</div>

				<!-- Выставлять статус - В сети -->
				<div class="ids__elm-settings-item">
					<div class="ids__elm-settings-item-key">
						<UiSwitcher
							:is-array-items="true"
							name="keepOnlineStatus"
							:is-checked="isKeepOnlineStatus"
							v-on:checked-item="handleChecked"
						/>
					</div>
					<div class="ids__elm-settings-item-val">
						Выставлять статус - (В сети)
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import UiSwitcher from "@/components/ui/UiSwitcher.vue";
import IconCopy from "@/components/icons/IconCopy.vue";
import { mapActions, mapGetters } from "vuex";
import { IInstanceDetail } from "@/interfaces/IInstanceDetail";
import { EventLogField } from "@/enum/EventLogField";

@Options({
	components: { IconCopy, UiSwitcher },

	computed: {
		...mapGetters("instanceModule", {
			instance: "getInstance",
		}),
	},

	methods: {
		...mapActions("instanceModule", ["setSettingsInstanceAction"]),
	},
})
export default class InstanceDetailSettings extends Vue {
	public url = "";
	public urlStr = "";
	public timeId = 0;
	public isFocus = false;

	// Константы
	readonly TRUE = "true";
	readonly FALSE = "false";
	readonly DELAY_SEND_MESSAGE = "300";

	// ************************************************************
	// Define mapGetters
	public instance: IInstanceDetail;

	// ************************************************************
	// Define mapActions
	public setSettingsInstanceAction!: (payload: {
		instance: number;
		token: string;
		channel?: string;
		settings: object;
		field: string;
		oldValue: string;
		newValue: string;
	}) => Promise<void>;

	public SETTINGS = {
		countryInstance: "",
		delaySendMessagesMilliseconds: "",
		deviceWebhook: "",
		enableMessagesHistory: "",
		incomingWebhook: "",
		instance_id: 0,
		keepOnlineStatus: "",
		markIncomingMessagesReaded: "",
		markIncomingMessagesReadedOnReply: "",
		outgoingAPIMessageWebhook: "",
		outgoingMessageWebhook: "",
		outgoingWebhook: "",
		stateWebhook: "",
		statusInstanceWebhook: "",
		webhookUrl: "",
	};

	/**
	 * Computed
	 * Настройки инстанса
	 */
	public get settings() {
		return this.instance?.instanceSettings;
	}

	/**
	 * Возвращает канал инстанса для сохранения настроек через нужный API.
	 */
	public get currentChannel() {
		// Канал нужен бэкенду, чтобы отправить настройки в WAPI или TAPI сервис.
		return (this.$route.query.channel as string) || this.instance?.channel;
	}

	/**
	 * Computed
	 * Отмечать входящие сообщения прочитанными
	 */
	public get isMarkIncomingMessagesRead() {
		return this.settings?.markIncomingMessagesReaded === this.TRUE;
	}

	/**
	 * Computed
	 * Отмечать входящие сообщения прочитаннымы при отправке через API
	 */
	public get isMarkIncomingMessagesReadOnReply() {
		return this.settings?.markIncomingMessagesReadedOnReply === this.TRUE;
	}

	/**
	 * Computed
	 * Интервал отправки сообщений из очереди
	 */
	public get delaySendMessagesMilliseconds() {
		return this.settings?.delaySendMessagesMilliseconds;
	}

	/**
	 * Computed
	 * Возвращает webhookUrl
	 */
	public get webhookUrl() {
		return this.settings?.webhookUrl || this.url;
	}
	public set webhookUrl(val: string) {
		this.url = val;
	}

	/**
	 * Computed
	 * Получать уведомления о статусах отправленных сообщениях
	 */
	public get isOutgoingWebhook() {
		return this.settings?.outgoingWebhook === this.TRUE;
	}

	/**
	 * Computed
	 * Получать уведомления о входящих сообщениях и файлах
	 */
	public get isIncomingWebhook() {
		return this.settings?.incomingWebhook === this.TRUE;
	}

	/**
	 * Computed
	 * Получать уведомления о сообщениях, отправленных с телефона
	 */
	public get isOutgoingMessageWebhook() {
		return this.settings?.outgoingMessageWebhook === this.TRUE;
	}

	/**
	 * Computed
	 * Получать уведомления о сообщениях, отправленных с API
	 */
	public get isOutgoingAPIMessageWebhook() {
		return this.settings?.outgoingAPIMessageWebhook === this.TRUE;
	}

	/**
	 * Computed
	 * Получать уведомления об изменении состояния авторизации аккаунта
	 */
	public get isStateWebhook() {
		return this.settings?.stateWebhook === this.TRUE;
	}

	/**
	 * Computed
	 * Выставлять статус - В сети
	 */
	public get isKeepOnlineStatus() {
		return this.settings?.keepOnlineStatus === this.TRUE;
	}

	/**
	 * Переводим boolean в string
	 * 'true' || 'false'
	 * @param val
	 */
	public boolToString(val: boolean) {
		return val ? this.TRUE : this.FALSE;
	}

	/**
	 * Если кликнули в район поля ввода, то устанавливаем фокус
	 */
	public onFocus() {
		this.isFocus = true;
		const inputUrl = this.$refs.inputUrl as HTMLInputElement;

		setTimeout(() => {
			inputUrl.focus();
		}, 100);
	}

	/**
	 * Скрываем input, если кликнули за его пределами
	 */
	public onFocusOut() {
		this.isFocus = false;
		const settings =
			this.settings !== undefined ? this.settings : this.SETTINGS;

		settings["webhookUrl"] = this.urlStr;
		this.webhookUrl = settings["webhookUrl"];

		clearTimeout(this.timeId);
		this.timeId = setTimeout(async () => {
			// Номер инстанса из адресной строки
			const instance = Number(this.$route.params.id);

			// Сохраняем изменения
			await this.setSettingsInstanceAction({
				instance: instance,
				token: this.instance.token,
				channel: this.currentChannel,
				settings: settings,
				field: EventLogField["WEBHOOK_URL"],
				oldValue: this.settings?.webhookUrl,
				newValue: this.webhookUrl,
			});
		}, 500);
	}

	/**
	 * Содержимое копируется в буфер обмена, только если используется https
	 */
	public async onClipboard() {
		const inputUrl = this.$refs.inputUrl as HTMLInputElement;

		try {
			await navigator.clipboard.writeText(inputUrl.value);
		} catch (err) {
			console.error("Ошибка копирования в буфер обмена: ", err);
		}
	}

	/**
	 * Обрабртка события input
	 * Адрес отправки уведомлений (URL)
	 */
	public inputUrl(event: Event) {
		this.urlStr = (event.target as HTMLInputElement).value;
	}

	/**
	 * Обработка изменения настроек
	 * @param value
	 */
	public async handleChecked(value: { name: string; isActive: boolean }) {
		const settings =
			this.settings !== undefined ? this.settings : this.SETTINGS;

		let field = "";

		switch (value.name) {
			case "markIncomingMessagesReaded":
				settings[value.name] = this.boolToString(value.isActive);
				field = EventLogField[value.name];
				break;
			case "markIncomingMessagesReadedOnReply":
				settings[value.name] = this.boolToString(value.isActive);
				field = EventLogField[value.name];
				break;
			case "incomingWebhook":
				settings[value.name] = this.boolToString(value.isActive);
				field = EventLogField[value.name];
				break;
			case "outgoingWebhook":
				settings[value.name] = this.boolToString(value.isActive);
				field = EventLogField[value.name];
				break;
			case "outgoingMessageWebhook":
				settings[value.name] = this.boolToString(value.isActive);
				field = EventLogField[value.name];
				break;
			case "outgoingAPIMessageWebhook":
				settings[value.name] = this.boolToString(value.isActive);
				field = EventLogField[value.name];
				break;
			case "stateWebhook":
				settings[value.name] = this.boolToString(value.isActive);
				field = EventLogField[value.name];
				break;
			case "keepOnlineStatus":
				settings[value.name] = this.boolToString(value.isActive);
				field = EventLogField[value.name];
				break;
		}

		const oldVal = this.boolToString(!value.isActive);
		const newVal = this.boolToString(value.isActive);

		// Номер инстанса из адресной строки
		const instance = Number(this.$route.params.id);

		// По умолчанию
		settings["instance_id"] = instance;
		settings["delaySendMessagesMilliseconds"] = this.DELAY_SEND_MESSAGE;

		// Сохраняем изменения
		await this.setSettingsInstanceAction({
			instance: instance,
			token: this.instance.token,
			channel: this.currentChannel,
			settings: settings,
			field: field,
			oldValue: oldVal,
			newValue: newVal,
		});
	}
}
</script>

<style scoped lang="scss">
.ids {
	display: flex;
	justify-content: center;

	&__elm {
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		max-width: 649px;
	}

	&__elm-settings {
		display: flex;
		flex-direction: column;
		padding: 24px;
		background: rgb(255, 255, 255);
		border-radius: 12px;
		box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.02);
	}

	&__elm-settings-label {
		color: rgb(49, 49, 50);
		font-size: 20px;
		font-weight: 600;
	}

	&__elm-settings-label_notify {
		padding-top: 24px;
		color: rgb(49, 49, 50);
		font-size: 20px;
		font-weight: 600;
	}

	&__elm-settings-item {
		display: flex;
		align-items: center;
		padding-top: 16px;
		color: rgb(49, 49, 50);
		font-size: 16px;
	}

	&__elm-settings-item-val {
		color: rgb(49, 49, 50);
		font-size: 16px;
		padding-left: 10px;
	}

	&__elm-settings-line {
		padding-top: 20px;
		border-bottom: 1px solid rgb(223, 230, 238);
	}

	&__elm-settings-interval {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-top: 16px;
	}

	&__elm-settings-interval-key {
		font-size: 16px;
		color: rgb(49, 49, 50);
	}

	&__elm-settings-interval-val {
	}

	&__elm-settings-interval-val-msec {
		padding: 14px 18px;
		border-radius: 12px;
		background: rgb(244, 246, 250);
		color: rgb(49, 49, 50);
		width: 60px;
	}

	&__elm-settings-url-label {
		padding: 14px 0 6px;
		color: rgb(49, 49, 50);
		font-size: 14px;
	}

	&__elm-settings-url {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 14px;
		border-radius: 12px;
		background: rgb(244, 246, 250);
	}

	&__elm-settings-url-wrap {
		flex-grow: 1;
	}

	&__elm-settings-url-wrap-link {
		color: rgb(49, 49, 50);
		font-size: 16px;
		height: 25px;
	}

	&__elm-settings-url-wrap-input {
		background-color: rgb(244, 246, 250);
		border: 1px solid rgb(244, 246, 250);
		font-size: 16px;
		width: 90%;
	}

	&__elm-settings-url-wrap-input:focus {
		outline-color: rgb(244, 246, 250);
		outline-style: solid;
	}

	&__elm-settings-url-copy-icon {
		cursor: pointer;
	}

	@media screen and (max-width: 768px) {
		&__elm {
			display: flex;
			flex-direction: column;
			flex-grow: 1;
			padding: 0 12px;
			min-width: 100px;
		}

		&__elm-settings {
			padding: 16px;
		}

		&__elm-settings-item {
			justify-content: space-between;
			flex-direction: row-reverse;
		}

		&__elm-settings-url-wrap-link {
			color: rgb(49, 49, 50);
			font-size: 16px;
			background: linear-gradient(
				88.69deg,
				rgb(49, 49, 50) -4.35%,
				rgb(49, 49, 50) 4.71%,
				rgb(49, 49, 50) 13.77%,
				rgb(49, 49, 50) 22.83%,
				rgb(49, 49, 50) 31.89%,
				rgb(75, 74, 74) 40.95%,
				rgb(113, 113, 115) 50%,
				rgb(188, 188, 190) 59.06%,
				rgb(188, 188, 190) 68.12%,
				rgb(188, 188, 190) 77.18%,
				rgb(213, 213, 213) 94.4%,
				rgb(202, 202, 204) 95.3%,
				rgb(238, 228, 228) 98%,
				rgb(229, 228, 228) 100%
			);
			line-height: 1;
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;

			/* Обрезка текста */
			white-space: nowrap; // текст в одну строку
			overflow: hidden; // скрывает все что выходит за зону контейнера
		}
	}
}
</style>
